'use strict';

// ::::::::::::::::::::::::::::::::::::::::::::: file description
// :: 
// :: Here are general utility classes collected
// :: 
// :: 

export class DataHandler {
	static request(requestUrl, callback) {
		const oReq = new XMLHttpRequest();
		oReq.onload = (e) => { callback(e.target.responseText); };
		oReq.open("get", c.rootFolder + requestUrl, true);
		oReq.send();
	}
}

// ::::::::::::::::::::::::::::::::::::::::::::: browser

export const getBrowser = () => {
	const N = navigator.appName;
	const ua = navigator.userAgent;
	let tem;
	let M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
	if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
	M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
	return M[0];
};

export const getBrowserVersion = () => {
	const N = navigator.appName;
	const ua = navigator.userAgent;
	let tem;
	let M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
	if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
	M =  M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
	return M[1];
};

export const getMsBrowser = () => {
    if (/*@cc_on!@*/false || !!document.documentMode) {
        return 'ie';
    }
    if (/Edge/.test(navigator.userAgent) || !!window.StyleMedia) {
        return 'edge';
    }
    return false;
}
export const storageAvailable = (type) => {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}

// ::::::::::::::::::::::::::::::::::::::::::::: data types

export function cEnum(obj) {
	const keysByValue = new Map();
	const EnumLookup = (value) => { keysByValue.get(value); };

	for (const key of Object.keys(obj)) {
		EnumLookup[key] = obj[key];
		keysByValue.set(EnumLookup[key], key);
	}

	// Return a function with all your enum properties attached.
	// Calling the function with the value will return the key.
	return Object.freeze(EnumLookup);
}

let isFunction = function(obj) {  
    return typeof obj == 'function' || false;
};

// ::::::::::::::::::::::::::::::::::::::::::::: math

function clamp(value, outMin, outMax) {
	const min = Math.max(outMin, outMax);
	const max = Math.min(outMin, outMax);
	return Math.min(min, Math.max(max, value));
}

export function Mapolator(value, inMin, inMax, outMin, outMax, bClamp = true) {
	const base = (value - inMin) / (inMax - inMin);
	const mapped = (outMax - outMin) * base + outMin;
	return bClamp ? clamp(mapped, outMin, outMax) : mapped;
}

// ::::::::::::::::::::::::::::::::::::::::::::: font calculations

export const autoSizeText = (selector) => {
    $(selector).each((i,e) => {
        const wasHidden = $(e).is(':visible'); 
        const mom = $(e).parent();
        const h = mom.height();
        const eh = $(e).height();
        const ratio = eh/h;
        const size = Math.min(parseInt(parseInt($(e).css('font-size')) * ratio), 32);
        const fontSize = `${size}px`;
        const lineHeight = `${size*6.2}px`;
        //$(e).css('font-size',fontSize);
        $(e).find('br').css('line-height',lineHeight);
    });
};

// ::::::::::::::::::::::::::::::::::::::::::::: events

export class EventEmitter { 

	constructor() {
	  	this.listeners = new Map();
	}

	addListener(label, callback) {
	  	this.listeners.has(label) || this.listeners.set(label, []);
	  	this.listeners.get(label).push(callback);
	}

	removeListener(label, callback) {  
	    let listeners = this.listeners.get(label),
	        index;

	    if (listeners && listeners.length) {
	        index = listeners.reduce((i, listener, index) => {
	            return (isFunction(listener) && listener === callback) ?
	                i = index :
	                i;
	        }, -1);

	        if (index > -1) {
	            listeners.splice(index, 1);
	            this.listeners.set(label, listeners);
	            return true;
	        }
	    }
	    return false;
	}
	emit(label, ...args) {  
	    let listeners = this.listeners.get(label);
	    if (listeners && listeners.length) {
	        listeners.forEach((listener) => {
	            listener(...args); 
	        });
	        return true;
	    }
	    return false;
	}
}

export class Observer {  
  constructor(id) {
    this.id = id;
  }
  onChange(data) {
    console.log(`${this.id} notified of change:`, data);
  }
}

